import PrerenderManager from 'helpers/prerenderManager/prerenderManager';
import { useState, useEffect } from 'react';

export const usePrerenderComponentsRequired = ({
    canBeAdded = true,
    componentNames,
}: {
    canBeAdded?: boolean;
    componentNames: string[];
}) => {
    const [hasInformPrerenderingManager, setHasInformPrerenderingManager] =
        useState(false);

    useEffect(() => {
        if (PrerenderManager && canBeAdded && !hasInformPrerenderingManager) {
            setHasInformPrerenderingManager(true);
            PrerenderManager.updateRequiredComponents(componentNames);
        }
    }, [canBeAdded, hasInformPrerenderingManager, componentNames]);
};
